export const CASE_STATUS_NOTIFICATION_OPTIONS = [
  { value: 'closed', label: 'Closed' },
  { value: 'completed', label: 'Completed' },
  { value: 'mrr_completed', label: 'MRR Completed' },
  { value: 'mrr_delivered', label: 'MRR Delivered' },
  { value: 'delivered', label: 'Delivered' },
] as const;

export type CaseStatusNotificationStatus = typeof CASE_STATUS_NOTIFICATION_OPTIONS[number]['value'];

export const DEFAULT_CASE_STATUS_NOTIFICATION_STATUSES: CaseStatusNotificationStatus[] =
  CASE_STATUS_NOTIFICATION_OPTIONS.map((option) => option.value);

export const getCaseStatusNotificationLabel = (status: string): string => {
  const match = CASE_STATUS_NOTIFICATION_OPTIONS.find((option) => option.value === status);
  return match?.label ?? status;
};
